import { Box, Card, CardContent, Typography, Icon } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  borderRadius: '20px',
  background: theme.palette.mode === 'dark'
    ? 'rgba(30, 41, 59, 0.6)'
    : 'rgba(255, 255, 255, 0.9)',
  backdropFilter: 'blur(20px)',
  border: `2px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)'}`,
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: 'translateY(-8px)',
    border: `2px solid ${theme.palette.mode === 'dark' ? 'rgba(16, 185, 129, 0.4)' : 'rgba(37, 99, 235, 0.3)'}`,
    boxShadow: theme.palette.mode === 'dark'
      ? '0 16px 48px rgba(16, 185, 129, 0.2)'
      : '0 16px 48px rgba(37, 99, 235, 0.15)',
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  width: '64px',
  height: '64px',
  borderRadius: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
  marginBottom: '20px',
  boxShadow: theme.palette.mode === 'dark'
    ? '0 8px 24px rgba(16, 185, 129, 0.3)'
    : '0 8px 24px rgba(37, 99, 235, 0.25)',
}));

interface ProductFeatureCardProps {
  icon: string;
  title: string;
  description: string;
}

export default function ProductFeatureCard({ icon, title, description }: ProductFeatureCardProps) {
  return (
    <StyledCard>
      <CardContent sx={{ p: 3 }}>
        <IconWrapper>
          <Icon sx={{ fontSize: 32, color: '#FFFFFF' }}>{icon}</Icon>
        </IconWrapper>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            mb: 1.5,
            fontSize: '1.1rem',
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ lineHeight: 1.7 }}
        >
          {description}
        </Typography>
      </CardContent>
    </StyledCard>
  );
}